export default __webpack_public_path__ + "static/media/peng.695856cd.png";